<template>
    <div>
        <div id="page">
            <div class="page-content">
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style text-center" style="margin-top:50px">
                    <div>
                        <div class="content pb-2">
                            <div class="mb-5">
                                <i class="fa fa-exclamation-triangle color-red1-dark fa-5x pt-3 icon-size"></i>
                            </div>
                            <div class="mb-5">
                                <p>
                                   این صفحه در دسترس نمی باشد.
                                </p>
                            </div>
                            <a href="/" class="btn btn-m btn-full rounded-s shadow-xl font-900 bg-green1-light add-button">
                                <i class="fa fa-redo ml-2"></i>
                                بازگشت به صفحه اصلی
                            </a>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!--<script>
    export default {
        data() {
            return {
                showInBazar: false,
                info: null,
                status: this.$route.params.adminOrUser,
                taskOnlinePayForFreeMessage: ""
            }
        },
        computed: {
            isAdmin() {
                return this.$store.getters.GetIsAdmin;
            },

        },
        created() {
            //this.$http
            //    .get("Task/GetPayInBazarAllowAnonymous")
            //    .then((data) => {
            //        var res = data.data;
            //        this.showInBazar = res.isSuccess;
            //    });
            this.$http
                .get("TaskOnline/GetTaskOnlinePayForFreeMessage")
                .then((data) => {
                    this.taskOnlinePayForFreeMessage = data.data;
                });
        },
        methods: {
            CheckIsEnable() {
                console.log("log");
                window.location = "/";
            },
            SignOutUser() {
                this.$store.dispatch("SignOutUser");
            },
        }
    }
</script>-->